export enum EModeleAppareilAir {
    AIRIDEAL = 1,
    AIRIDEAL3P ,
    MAS100ECO,
    MAS100NT,
    SamplAirLite,
    SAS360AirSamplerDuo,
    SASDUO360,
    SASSuperDUO360,
    SASSUPERDUO,
    SASSUPERIAQ,
}